export const apiEndpoint = {
  registration: '/registration/',
  event: '/event/',
  contact_us: '/contact_us/',
};
